import { ColumnNode as ColumnSchema } from '@seen/core/tiptap/schema'

/* The column's layout classes. Supplied as an options.HTMLAttributes entry
 * rather than written into the shared schema's renderHTML, because Tailwind
 * only emits CSS for class names it finds while scanning packages/react/src and
 * packages/ui/src — moving this string into @seen/core would purge the rules
 * and silently unstyle every column. Server-rendered HTML therefore carries no
 * class here, which costs nothing: an options-supplied attribute cannot alter
 * document content, and every reader re-derives the class from this schema. */
export const ColumnNode = ColumnSchema.configure({
  HTMLAttributes: {
    class: 'min-h-8 min-w-0 overflow-hidden max-w-(--container-prose)',
  },
})
